<template>
    <div class="rounded bg-white shadow p-4">

        <div class="flex justify-between flex-col lg:flex-row">
            <div class="mr-4 mb-4">
                <a class="cursor-pointer rounded-full flex flex-row bg-teal text-white py-2 items-center hover:bg-teal-dark"
                   @click="editX = true">
                    <div class="lg:px-8 px-4">
                        <span class=""><i class="fa fa-chevron-down"></i></span>
                    </div>
                    <div class="flex flex-col">
                        <div class="text-sm text-grey-lighter font-bold uppercase">
                            Country
                        </div>
                        <span class="pr-4 lg:pr-16">{{ x.text }}</span>
                    </div>
                </a>
                <modal v-if="editX" @close="editX=false">
                    <template slot="header">Select Country</template>
                    <single-select-filter :root="root" :database="database" class="bg-white"
                                          @code="handleX"></single-select-filter>
                </modal>
            </div>

            <div class="mr-4 mb-4">
                <a class="cursor-pointer rounded-full flex flex-row bg-teal text-white py-2 items-center hover:bg-teal-dark"
                   @click="editY = true">
                    <div class="lg:px-8 px-4">
                        <span class=""><i class="fa fa-chevron-down"></i></span>
                    </div>
                    <div class="flex flex-col">
                        <div class="text-sm text-grey-lighter font-bold uppercase">
                            Country
                        </div>
                        <span class="pr-4 lg:pr-16">{{ y.text }}</span>
                    </div>
                </a>
                <modal v-if="editY" @close="editY=false">
                    <template slot="header">Select Y-axis</template>
                    <single-select-filter :root="root" :database="database" class="bg-white"
                                          @code="handleY"></single-select-filter>
                </modal>
            </div>

            <!--<div class="flex items-center flex-wrap">
                <button v-for="(value, index) in region" class="mb-2 py-2 px-4 mr-2 rounded-full focus:outline-none"
                        :class="{'bg-blue-dark text-white': value, 'bg-grey-light': !value}"
                        @click="region[index]=!value">
                    {{ index }}
                </button>
            </div>-->
        </div>

        <div class="flex-1 my-4">
            <div v-show="loading" class="bg-grey-light w-full h-64"></div>

            <div v-show="!loading">
                <div ref="chart"></div>
            </div>

        </div>

        <div class="pt-2 text-grey text-right text-sm">Source: World Bank, Washington</div>

    </div>
</template>

<script>

    import DatabaseFilter from "../components/database/Filter";
    import SingleSelectFilter from "../components/database/SingleSelectFilter";
    import Modal from "../dashboard/components/Modal";

    export default {

        components: {
            SingleSelectFilter,
            DatabaseFilter,
            Modal,
        },

        provide() {
            return {
                codes: this.codes,
            }
        },

        props: ['left', 'right'],

        mounted() {
            window.http
                .get(
                    '/api/v1/indicators/' + this.database + '/original/' + 'CNT',
                )
                .then(response => {
                    this.root = response.data.data.id;
                });

            window.http
                .get(
                    '/api/v1/indicators/' + this.database + '/original/' + this.left, //this.$route.params.original,
                )
                .then(response => {
                    this.x = response.data.data;
                    this.loadData(this.x.id);
                });

            window.http
                .get(
                    '/api/v1/indicators/' + this.database + '/original/' + this.right, //this.$route.params.original,
                )
                .then(response => {
                    this.y = response.data.data;
                    this.loadData(this.y.id);
                });
        },

        watch: {
            region: {
                handler() {
                    this.doChart()
                },
                deep: true,
            },
        },

        data() {
            return {
                items: {
                    climate: ['EN.ATM.CO2E.PC', 'EN.ATM.GHGT.KT.CE'],
                    energy: ['EG.ELC.RNEW.ZS'], // renewable electricity vs EG.ELC.FOSL.ZS // energy from gas/oil & coal
                    land: ['AG.LND.FRST.ZS'], // forest area % of land
                    transport: ['IS.AIR.GOOD.MT.K1', 'IS.RRS.GOOD.MT.K6']
                },
                details: false,
                editX: false,
                editY: false,
                database: 'wb_wdi',
                codes: {
                    selected: [],
                },
                x: {},
                y: {},
                loading: false,
                dataX: null,
                root: '1',
            };
        },

        computed: {
            hasData() {
                return this.dataX !== null;
            },
            best: function () {
                if (!this.hasData) {
                    return [];
                }

                return this.series[0].data;//.slice(0, 10);
            },
            series: function () {
                if (!this.hasData) {
                    return [];
                }

                // extract last data point

                let x = _.keyBy(this.getLatest(this.dataX), function (item) {
                    return item.name;
                });

                let result = _.map(x, function (x, key) {
                    return {
                        name: key,
                        y: x.value,
                        year: x.time,
                    }
                });


                // [, , ,, , , , , , , , , ]
                let that = this;
                result = result.filter(function (item) {
                    if (that.region.europe && ["Kosovo", "Macedonia", "Montenegro", "Romania", "Slovenia", "Isle of Man", "Portugal", "Lithuania", "Liechtenstein", "Iceland", "Croatia", "Greenland", "Denmark", "Cyprus", "Switzerland", "Bosnia and Herzegovina", "Armenia", "Albania", 'Belarus', 'Greece', 'Serbia', 'Poland', 'Luxembourg', 'Belgium', 'Ukraine', 'Slovak Republic', 'Hungary', 'Bulgaria', 'San Marino', 'Moldova', 'Malta', 'Latvia', 'Austria', 'Germany', 'Czech Republic', 'Lichtenstein', 'Ireland', 'Estonia', 'Italy', 'France', 'Netherlands', 'Spain', 'Finland', 'Norway', 'Sweden', 'United Kingdom'].includes(item.name)) {
                        return true;
                    }

                    if (that.region.asia && ["Vietnam", "Uzbekistan", "Timor-Leste", "Tajikistan", "Solomon Islands", "French Polynesia", "Papua New Guinea", "Palau", "New Caledonia", "Myanmar", "Marshall Islands", "Maldives", "Sri Lanka", "Pakistan", "Mongolia", "Lebanon", "Lao PDR", "Kyrgyz Republic", "Qatar", "Dem. People's Rep. Korea", "Macao SAR, China", "Korea", "Kazakhstan", "Jordan", "Iran", "India", "Indonesia", "Hong Kong SAR, China", "Bhutan", "Brunei", "Bangladesh", "Azerbaijan", 'Syrian Arab Republic', 'Thailand', 'West Bank and Gaza', 'Israel', 'Afghanistan', 'Saudi Arabia', 'Georgia', 'Turkmenistan', 'Singapore', 'Philippines', 'Nepal', 'Cambodia', 'Iraq', 'Japan', 'Russia', 'Turkey', 'Kuwait', 'United Arab Emirates', 'Bahrain', 'Benin', 'China',].includes(item.name)) {
                        return true;
                    }

                    if (
                        that.region.africa
                        && ["Zimbabwe", "Uganda", "Tanzania", "Seychelles", "Eswatini", "Somalia", "Senegal", "Sudan", "Nigeria", "Niger", "Malaysia", "Mauritius", "Mauritania", "Lesotho", "Tunisia", 'Comoros', 'Equatorial Guinea', "Mali", "Liberia", "SÃ£o TomÃ© and Principe", "Guinea-Bissau", "Guinea", "Cabo Verde", "Madagascar", "Ghana", "Cameroon", "CÃ´te d'Ivoire", "Botswana", "Burkina Faso", 'Angola', 'Zambia', 'Rwanda', 'Mozambique', 'Malawi', 'Namibia', 'Oman', 'Morocco', 'Kenya', 'Central African Republic', 'Dem. Rep. Congo', 'South Africa', 'Togo', 'Trinidad and Tobago', 'Sierra Leone', 'Ecuador', 'Burundi', 'Yemen', 'Tonga', 'South Sudan', 'Libya', 'The Gambia', 'Gabon', 'The Gambia', 'Chad', 'Algeria', 'Congo', 'Egypt', 'Eritrea', 'Ethiopia', 'Djibouti'].includes(item.name)
                    ) {
                        return true;
                    }

                    if (
                        that.region.america
                        && ["Virgin Islands", "St. Lucia", "St. Vincent and the Grenadines", "Uruguay", "Venezuela", "Sint Maarten (Dutch part)", "El Salvador", "Paraguay", "Puerto Rico", "Panama", "Nicaragua", "United States", "St. Kitts and Nevis", "Haiti", "Guyana", "Guatemala", "Dominican Republic", "Dominica", "Cayman Islands", "CuraÃ§ao", "Costa Rica", "Colombia", "Channel Islands", "Bolivia", "The Bahamas", 'Peru', 'Mexico', 'Bermuda', 'Honduras', 'Canada', 'Belize', 'Aruba', 'Argentina', 'Suriname', 'Gyana', 'Grenada', 'Brazil', 'Jamaica', 'Faroe Islands', 'Chile', 'Cuba'].includes(item.name)
                    ) {
                        return true;
                    }

                    if (
                        that.region.australia
                        && ["New Zealand", 'Australia'].includes(item.name)
                    ) {
                        return true;
                    }

                    if (
                        that.region.oceania
                        && ["Samoa", "Vanuatu", "St. Martin (French part)", "Kiribati", "Micronesia", "Fiji", "Barbados", "Antigua and Barbuda", 'Guam', 'Venuatu'].includes(item.name)
                    ) {
                        return true;
                    }

                    // aggregates
                    if (
                        ['Caribbean small states', "Sub-Saharan Africa", "Sub-Saharan Africa (excluding high income)", "East Asia & Pacific (IDA & IBRD)", "Europe & Central Asia (IDA & IBRD)", "Latin America & Caribbean (IDA & IBRD)", "Middle East & North Africa (IDA & IBRD)", "South Asia (IDA & IBRD)", "Sub-Saharan Africa (IDA & IBRD)", "Post-demographic dividend", "Pacific island small states", "Pre-demographic dividend", "Middle East & North Africa (excluding high income)", "Middle income", "Least developed countries: UN classification", "Latin America & Caribbean", "Latin America & Caribbean (excluding high income)", "IDA total", "Heavily indebted poor countries (HIPC)", "High income", "Fragile and conflict affected situations", "East Asia & Pacific", "Early-demographic dividend", "East Asia & Pacific (excluding high income)", "Central Europe and the Baltics", 'North America', 'IDA & IBRD total', 'World', 'Small states', 'Low income', 'Lower middle income', 'OECD members', 'Upper middle income', 'South Asia', 'Other small states', 'Low & middle income', 'IBRD only', 'IDA only', 'European Union', 'Europe & Central Asia', 'IDA blend', 'Late-demographic dividend', 'Middle East & North Africa', 'Arab World', 'Europe & Central Asia (excluding high income)', 'Euro area'].includes(item.name)
                    ) {
                        return false;
                    }

                    return false;
                });

                result = _.sortBy(result, 'y').reverse();


                return [{
                    name: 'Values',
                    data: result,
                }];
            },
            minX() {
                if (!this.hasData) {
                    return null;
                }

                let x = this.series[0].data.map(function (item) {
                    return item.y;
                });

                return Math.min(...x);
            },
            maxX() {
                if (!this.hasData) {
                    return null;
                }

                let x = this.series[0].data.map(function (item) {
                    return item.y;
                });

                return Math.max(...x);
            },
            categories() {
                if (!this.hasData) {
                    return [];
                }

                return this.series[0].data.map(function (item) {
                    return item.name;
                });
            },
        },

        methods: {
            getLatest(result) {
                return result.data.map(function (series) {
                    let latest = series.observations[series.observations.length - 1];

                    return {
                        name: series.description,
                        value: latest.value,
                        time: latest.time.substr(0, 4),
                    };
                });
            },
            handleX(code) {
                this.x = code;
                this.editX = false;
                //history.pushState({}, this.x.text, this.x.original);
                this.loadData(this.x.id, true);
            },
            handleY(code) {
                this.y = code;
                this.editY = false;
                //history.pushState({}, this.x.text, this.x.original);
                this.loadData(this.y.id, true);
            },
            loadData(field) {

                this.loading = true;

                let params = {

                    latest: true,
                };
                params[this.root] = [field];

                // TODO optimize this query! pleanty of room: e.g. limit to latest data only!
                window.http
                    .get(
                        '/api/v1/indicators/' + this.database + '/data',
                        {
                            params: params,
                        }
                    )
                    .then(response => {
                        this.dataX = response.data.charts[0];

                        this.loading = false;
                        this.doChart();
                    }, response => {
                        this.error = response.data;
                        this.loading = false;
                    });
            },
            doChart() {
                if (!this.hasData) {
                    return false;
                }

                const json = {
                    chart: {
                        renderTo: this.$refs.chart,
                        type: 'column',
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        //gridLineWidth: 1,
                        /*labels: {
                            format: '{value}'
                        },*/
                        categories: this.categories,
                        type: 'category',
                        //min: this.minX,
                        //max: this.maxX,
                        //startOnTick: true,
                        //endOnTick: true,
                        title: {
                            text: this.x.text,
                        },
                    },
                    yAxis: {
                        min: this.minX,
                        max: this.maxX,
                    },
                    tooltip: {
                        headerFormat: '{point.key}<br>',
                        pointFormat: this.x.text + ': <b>{point.y:.2f}</b>',
                    },
                    series: this.series,
                    legend: {
                        enabled: false,
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: {
                        enabled: false,
                    },
                };

                new Highcharts.Chart(json);
            }
        }
    }
</script>